import actions from './actions'

const initialState = {
  items: null,
  params: null,
}

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
